(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 52970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ Hide; },
/* harmony export */   "di": function() { return /* binding */ Show; },
/* harmony export */   "Sx": function() { return /* binding */ useBreakpointValue; }
/* harmony export */ });
/* unused harmony exports useBreakpoint, useColorModePreference, useMediaQuery, usePrefersReducedMotion, useQuery */
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47386);
/* harmony import */ var _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80190);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56168);
/* harmony import */ var _chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37687);






var useSafeLayoutEffect = _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .isBrowser */ .jU ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
/**
 * React hook that tracks state of a CSS media query
 *
 * @param query the media query to match
 */

function useMediaQuery(query) {
  var env = (0,_chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__/* .useEnvironment */ .O)();
  var queries = Array.isArray(query) ? query : [query];
  var isSupported = _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .isBrowser */ .jU && "matchMedia" in env.window;

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(queries.map(function (query) {
    return isSupported ? !!env.window.matchMedia(query).matches : false;
  })),
      matches = _React$useState[0],
      setMatches = _React$useState[1];

  useSafeLayoutEffect(function () {
    if (!isSupported) return undefined;
    var mediaQueryList = queries.map(function (query) {
      return env.window.matchMedia(query);
    });
    var listenerList = mediaQueryList.map(function () {
      var listener = function listener() {
        var isEqual = function isEqual(prev, curr) {
          return prev.length === curr.length && prev.every(function (elem, idx) {
            return elem === curr[idx];
          });
        };

        var currentMatches = mediaQueryList.map(function (mediaQuery) {
          return mediaQuery.matches;
        });

        if (!isEqual(matches, currentMatches)) {
          setMatches(currentMatches);
        }
      };

      env.window.addEventListener("resize", listener);
      return listener;
    });
    return function () {
      mediaQueryList.forEach(function (_, index) {
        env.window.removeEventListener("resize", listenerList[index]);
      });
    };
  }, [query]);
  return matches;
}

/**
 * Visibility
 *
 * React component to control the visibility of its
 * children based on the current breakpoint
 */
var Visibility = function Visibility(props) {
  var breakpoint = props.breakpoint,
      hide = props.hide,
      children = props.children;

  var _useMediaQuery = useMediaQuery(breakpoint),
      show = _useMediaQuery[0];

  var isVisible = hide ? !show : show;
  var rendered = isVisible ? children : null;
  return rendered;
};

var Hide = function Hide(props) {
  var children = props.children;
  var query = useQuery(props);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Visibility, {
    breakpoint: query,
    hide: true
  }, children);
};

if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .__DEV__ */ .Ts) {
  Hide.displayName = "Hide";
}

var Show = function Show(props) {
  var children = props.children;
  var query = useQuery(props);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Visibility, {
    breakpoint: query
  }, children);
};

if (_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .__DEV__ */ .Ts) {
  Show.displayName = "Show";
}

var getBreakpoint = function getBreakpoint(theme, value) {
  return (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .memoizedGet */ .Wf)(theme, "breakpoints." + value, value);
};

function useQuery(props) {
  var _props$breakpoint = props.breakpoint,
      breakpoint = _props$breakpoint === void 0 ? "" : _props$breakpoint,
      below = props.below,
      above = props.above;
  var theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .useTheme */ .Fg)();
  var bpBelow = getBreakpoint(theme, below);
  var bpAbove = getBreakpoint(theme, above);
  var query = breakpoint;

  if (bpBelow) {
    query = "(max-width: " + bpBelow + ")";
  } else if (bpAbove) {
    query = "(min-width: " + bpAbove + ")";
  }

  return query;
}

/**
 * React hook used to get the user's animation preference.
 */

function usePrefersReducedMotion() {
  var _useMediaQuery = useMediaQuery("(prefers-reduced-motion: reduce)"),
      prefersReducedMotion = _useMediaQuery[0];

  return prefersReducedMotion;
}
/**
 * React hook for getting the user's color mode preference.
 */

function useColorModePreference() {
  var _useMediaQuery2 = useMediaQuery(["(prefers-color-scheme: light)", "(prefers-color-scheme: dark)"]),
      isLight = _useMediaQuery2[0],
      isDark = _useMediaQuery2[1];

  if (isLight) return "light";
  if (isDark) return "dark";
  return undefined;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function createMediaQueries(breakpoints) {
  return Object.entries(breakpoints) // sort css units in ascending order to ensure media queries are generated
  // in the correct order and reference to each other correctly aswell
  .sort(function (a, b) {
    return Number.parseInt(a[1], 10) > Number.parseInt(b[1], 10) ? 1 : -1;
  }).map(function (_ref, index, arr) {
    var breakpoint = _ref[0],
        minWidth = _ref[1];
    // given a following breakpoint
    var next = arr[index + 1]; // this breakpoint must end prior the threshold of the next

    var maxWidth = next ? next[1] : undefined;
    var query = createMediaQueryString(minWidth, maxWidth);
    return {
      minWidth: minWidth,
      maxWidth: maxWidth,
      breakpoint: breakpoint,
      query: query
    };
  });
}
/**
 * Create a media query string from the breakpoints,
 * using a combination of `min-width` and `max-width`.
 */

function createMediaQueryString(minWidth, maxWidth) {
  var hasMinWidth = parseInt(minWidth, 10) >= 0;

  if (!hasMinWidth && !maxWidth) {
    return "";
  }

  var query = "(min-width: " + toMediaString(minWidth) + ")";

  if (!maxWidth) {
    return query;
  }

  if (query) {
    query += " and ";
  }

  query += "(max-width: " + toMediaString(subtract(maxWidth)) + ")";
  return query;
}

var measurementRegex = /([0-9]+\.?[0-9]*)/;

var calculateMeasurement = function calculateMeasurement(value, modifier) {
  if (typeof value === "number") {
    return "" + (value + modifier);
  }

  return value.replace(measurementRegex, function (match) {
    return "" + (parseFloat(match) + modifier);
  });
};
/**
 * 0.01 and 0.1 are too small of a difference for `px` breakpoint values
 *
 * @see https://github.com/chakra-ui/chakra-ui/issues/2188#issuecomment-712774785
 */


function subtract(value) {
  return calculateMeasurement(value, value.endsWith("px") ? -1 : -0.01);
}
/**
 * Convert media query value to string
 */


function toMediaString(value) {
  return (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .isNumber */ .hj)(value) ? value + "px" : value;
}

var _excluded = ["query"],
    _excluded2 = ["query"];

/**
 * React hook used to get the current responsive media breakpoint.
 *
 * @param defaultBreakpoint default breakpoint name
 * (in non-window environments like SSR)
 *
 * For SSR, you can use a package like [is-mobile](https://github.com/kaimallea/isMobile)
 * to get the default breakpoint value from the user-agent
 */
function useBreakpoint(defaultBreakpoint) {
  var _useTheme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .useTheme */ .Fg)(),
      breakpoints = _useTheme.breakpoints;

  var env = (0,_chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__/* .useEnvironment */ .O)();
  var mediaQueries = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function () {
    return createMediaQueries(_extends({
      base: "0px"
    }, breakpoints));
  }, [breakpoints]);

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(function () {
    if (!defaultBreakpoint) {
      return undefined;
    }

    var mediaQuery = mediaQueries.find(function (_ref) {
      var breakpoint = _ref.breakpoint;
      return breakpoint === defaultBreakpoint;
    });

    if (mediaQuery) {
      mediaQuery.query;
          var breakpoint = _objectWithoutPropertiesLoose(mediaQuery, _excluded);

      return breakpoint;
    }

    return undefined;
  }),
      currentBreakpoint = _React$useState[0],
      setCurrentBreakpoint = _React$useState[1];

  var current = currentBreakpoint == null ? void 0 : currentBreakpoint.breakpoint;
  var update = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (query, breakpoint) {
    if (query.matches && current !== breakpoint.breakpoint) {
      setCurrentBreakpoint(breakpoint);
    }
  }, [current]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function () {
    var listeners = new Set();
    mediaQueries.forEach(function (_ref2) {
      var query = _ref2.query,
          breakpoint = _objectWithoutPropertiesLoose(_ref2, _excluded2);

      var mediaQuery = env.window.matchMedia(query); // trigger an initial update to determine media query

      update(mediaQuery, breakpoint);

      var handleChange = function handleChange() {
        update(mediaQuery, breakpoint);
      }; // add media query-listener


      mediaQuery.addListener(handleChange); // push the media query list handleChange
      // so we can use it to remove Listener

      listeners.add({
        mediaQuery: mediaQuery,
        handleChange: handleChange
      });
      return function () {
        // clean up 1
        mediaQuery.removeListener(handleChange);
      };
    });
    return function () {
      // clean up 2: for safety
      listeners.forEach(function (_ref3) {
        var mediaQuery = _ref3.mediaQuery,
            handleChange = _ref3.handleChange;
        mediaQuery.removeListener(handleChange);
      });
      listeners.clear();
    };
  }, [mediaQueries, breakpoints, update, env.window]);
  return current;
}

function getClosestValue(values, breakpoint, breakpoints$1) {
  if (breakpoints$1 === void 0) {
    breakpoints$1 = _chakra_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints */ .AV;
  }

  var index = Object.keys(values).indexOf(breakpoint);

  if (index !== -1) {
    return values[breakpoint];
  }

  var stopIndex = breakpoints$1.indexOf(breakpoint);

  while (stopIndex >= 0) {
    var key = breakpoints$1[stopIndex];

    if (values[key] != null) {
      index = stopIndex;
      break;
    }

    stopIndex -= 1;
  }

  if (index !== -1) {
    var _key = breakpoints$1[index];
    return values[_key];
  }

  return undefined;
}

/**
 * React hook for getting the value for the current breakpoint from the
 * provided responsive values object.
 *
 * @param values
 * @param defaultBreakpoint default breakpoint name
 * (in non-window environments like SSR)
 *
 * For SSR, you can use a package like [is-mobile](https://github.com/kaimallea/isMobile)
 * to get the default breakpoint value from the user-agent
 *
 * @example
 * const width = useBreakpointValue({ base: '150px', md: '250px' })
 */

function useBreakpointValue(values, defaultBreakpoint) {
  var breakpoint = useBreakpoint(defaultBreakpoint);
  var theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .useTheme */ .Fg)();
  if (!breakpoint) return undefined;
  /**
   * Get the non-number breakpoint keys from the provided breakpoints
   */

  var breakpoints = Object.keys(theme.breakpoints);
  var obj = (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .isArray */ .kJ)(values) ? (0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .fromEntries */ .sq)(Object.entries((0,_chakra_ui_utils__WEBPACK_IMPORTED_MODULE_1__/* .arrayToObjectNotation */ .Yq)(values, breakpoints)).map(function (_ref) {
    var key = _ref[0],
        value = _ref[1];
    return [key, value];
  })) : values;
  return getClosestValue(obj, breakpoint, breakpoints);
}




/***/ }),

/***/ 86057:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(91407);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 15302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80241);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52970);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var BrandLogo = function(_param) {
    var src = _param.src, alt = _param.alt, _w = _param.w, w = _w === void 0 ? [
        130
    ] : _w, _h = _param.h, h = _h === void 0 ? [
        60
    ] : _h, props = _objectWithoutProperties(_param, [
        "src",
        "alt",
        "w",
        "h"
    ]);
    var width = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .useBreakpointValue */ .Sx)(w);
    var height = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .useBreakpointValue */ .Sx)(h);
    if (width && height) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], _objectSpread({
            src: src,
            alt: alt,
            width: width,
            height: height
        }, props)));
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}));
};
/* harmony default export */ __webpack_exports__["Z"] = (BrandLogo);


/***/ }),

/***/ 63198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ NextSeo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22319);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var noIndexAndFollowPage = "production" !== 'production';
var NextSeo = function(props) {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, _objectSpread({}, props, {
        noindex: noIndexAndFollowPage,
        nofollow: noIndexAndFollowPage
    }));
};


/***/ }),

/***/ 55522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ companyColorScheme; }
/* harmony export */ });
var companyColorScheme = {
    errors: {
        100: '#FCEAEF',
        150: '#FB5A82',
        200: '#B81A4C'
    },
    primary: {
        50: '#FFFFFF',
        100: '#F0F0FF',
        150: '#f1ddfc',
        300: '#C570F3',
        500: '#9412DC',
        700: '#6E2B77',
        800: '#63266B',
        900: '#58225f'
    },
    secondary: {
        100: '#41A9B9',
        200: '#E0FBF6'
    },
    background: {
        50: '#939DA5',
        100: '#11273A',
        200: '#E2EFF1',
        700: '#FFFFFF',
        750: '#F8F8F8',
        800: '#f0f0ff',
        850: '#FBFBFB',
        900: '#F0F0FF',
        950: '#C7CBCF'
    },
    text: {
        100: '#000000',
        150: '#040C10',
        200: '#727272',
        300: '#6B757D'
    },
    text_attention: {
        100: '#E8A217'
    }
};


/***/ }),

/***/ 53087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ starredText; }
/* harmony export */ });
/* unused harmony export concatWords */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56168);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34237);


/**
 * Highlights the given words with the given style for the given text
 *
 * @param text the text to be queried and highlighted
 * @param starring the array containing the words to be highlighted
 * @param style the style of the highlighted words
 *
 * @returns the text with the highlighted words as a ReactElement
 */ var starredText = function(text, starring, style) {
    var textArray = text.split(' ');
    var starredTextArray = textArray.map(function(word, index, starredArray) {
        var newWord = index + 1 === starredArray.length ? word : "".concat(word, " ");
        return starring.includes(word.replace(',', '')) ? (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
            as: 'span',
            display: 'inline',
            /* eslint-disable react/no-array-index-key */ key: "".concat(word, "-").concat(index),
            style: style,
            'data-testid': 'starred-text'
        }, newWord) : newWord;
    });
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
        'data-testid': 'starred-container',
        display: 'inline',
        as: 'span'
    }, starredTextArray);
};
/**
 * Concat words with a common separator and a last separator
 * @param words the array of words to be concatenated with a common separator
 * @param separator the separator to be used between the words
 * @param lastSeparator the separator to be used between the last two words
 * @returns the text concatenated with the given separator
 */ var concatWords = function(words) {
    var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ',', lastSeparator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'e';
    var finalText = words.reduce(function(finalString, currentWord, index) {
        if (index === words.length - 2) {
            return "".concat(finalString).concat(currentWord, " ").concat(lastSeparator, " ");
        }
        return "".concat(finalString).concat(currentWord).concat(index !== words.length - 1 ? "".concat(separator, " ") : '');
    }, '');
    return finalText;
};


/***/ }),

/***/ 91407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(8014);
// EXTERNAL MODULE: ./src/lib/settings/theme/colors/company.ts
var company = __webpack_require__(55522);
// EXTERNAL MODULE: ./src/components/organisms/footer/index.tsx + 3 modules
var footer = __webpack_require__(81241);
// EXTERNAL MODULE: ./src/lib/constants/header.ts
var header = __webpack_require__(71458);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(34237);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(80241);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(75657);
// EXTERNAL MODULE: ./src/lib/constants/paths.ts
var paths = __webpack_require__(29770);
// EXTERNAL MODULE: ./src/components/atoms/button/index.tsx + 7 modules
var atoms_button = __webpack_require__(65186);
// EXTERNAL MODULE: ./src/components/atoms/heading/index.tsx
var heading = __webpack_require__(68590);
;// CONCATENATED MODULE: ./public/home/imagem-home.png
/* harmony default export */ var imagem_home = ({"src":"/_next/static/media/imagem-home.6897d163.png","height":700,"width":1080,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAQlBMVEWgoK+jc76eZMlYPlu0rLn///+1WuiYfqxZREBWRlNEKjueEfCgoL64raZCNTCOfbZyKZ17e4ZnZoaPjapiTFNmV3Hr/Sr5AAAAEnRSTlMBS/icIBMtDSu2PHfSSJ7tp+fHQBfFAAAACXBIWXMAAAsTAAALEwEAmpwYAAAALUlEQVR4nBXJxw0AIAwAsaOH3vdfFfGzZABpAcDnesaH0mV3C9i5bnQ/UzQCDxYlAQSV0IOjAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./public/home/circle-1.svg
/* harmony default export */ var circle_1 = ({"src":"/_next/static/media/circle-1.cd30b07b.svg","height":341,"width":232});
;// CONCATENATED MODULE: ./public/home/circle-2.svg
/* harmony default export */ var circle_2 = ({"src":"/_next/static/media/circle-2.1adc9e0b.svg","height":284,"width":140});
;// CONCATENATED MODULE: ./src/components/organisms/home/banner/circles/index.tsx





var Circles = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                bottom: -36,
                display: {
                    base: 'none',
                    lg: 'block'
                },
                position: "absolute",
                right: -12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                    alt: "Circulo 1",
                    height: "300px",
                    layout: "fixed",
                    src: circle_1,
                    width: "300px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                bottom: "20%",
                display: {
                    base: 'none',
                    lg: 'block'
                },
                left: -4,
                position: "absolute",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                    alt: "Circulo 2",
                    height: "313px",
                    layout: "fixed",
                    src: circle_2,
                    width: "250px"
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/home/banner/index.tsx









var HomePageBanner = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
        bgColor: "black.300",
        position: "relative",
        overflow: "hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Container */.W2, {
                maxW: "container.lg",
                overflow: "hidden",
                paddingX: {
                    base: 8,
                    xl: 0
                },
                position: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                        alignItems: "flex-start",
                        color: "primary.50",
                        flexDir: "column",
                        paddingBottom: 20,
                        paddingTop: 36,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(heading/* default */.Z, {
                                as: "h1",
                                mb: 4,
                                color: "text.300",
                                children: [
                                    "As melhores vagas",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "em empresas de",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "tecnologia 🚀"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                fontSize: "0.9rem",
                                mb: 8,
                                children: "Cadastre-se e comece sua experi\xeancia com a Geek"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                href: paths/* CANDIDATE_LP */.Is,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                                    p: 4,
                                    mb: 4,
                                    children: "Criar perfil gr\xe1tis"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                                fontSize: "0.9rem",
                                flexDirection: {
                                    base: 'column',
                                    sm: 'row'
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                        mr: 1,
                                        children: "Voc\xea \xe9 empresa? "
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                        href: {
                                            pathname: paths/* COMPANY_LP */.NL
                                        },
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                            cursor: "pointer",
                                            textDecor: "underline",
                                            children: "Contrate os melhores talentos do mercado"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                        bottom: 10,
                        display: {
                            base: 'none',
                            lg: 'block'
                        },
                        position: "absolute",
                        right: 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                            alt: "Homem recem contratado comemorando",
                            height: 370,
                            layout: "fixed",
                            priority: true,
                            src: imagem_home,
                            width: 580
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Circles, {})
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/molecules/home/benefitsCard/index.tsx



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var BenefitCard = function(_param) /*#__PURE__*/ {
    var src = _param.src, alt = _param.alt, title = _param.title, text = _param.text, props = _objectWithoutProperties(_param, [
        "src",
        "alt",
        "title",
        "text"
    ]);
    return (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, _objectSpread({
        h: "full",
        boxShadow: "md",
        paddingY: 8,
        paddingX: 6,
        maxW: {
            base: 320,
            md: 'full'
        },
        mb: {
            base: 6,
            md: 0
        }
    }, props, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                src: src,
                alt: alt,
                height: 58,
                width: 58
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                fontSize: "2xl",
                fontWeight: 600,
                mt: 2,
                mb: 6,
                lineHeight: 8,
                maxW: 200,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                fontSize: "md",
                color: "text.200",
                maxW: 240,
                children: text
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./src/components/molecules/home/jobSearchType/index.tsx




function jobSearchType_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function jobSearchType_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            jobSearchType_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function jobSearchType_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = jobSearchType_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function jobSearchType_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var JobSearchType = function(_param) /*#__PURE__*/ {
    var src = _param.src, imageHeight = _param.imageHeight, imageWidth = _param.imageWidth, alt = _param.alt, title = _param.title, subtitle = _param.subtitle, text = _param.text, props = jobSearchType_objectWithoutProperties(_param, [
        "src",
        "imageHeight",
        "imageWidth",
        "alt",
        "title",
        "subtitle",
        "text"
    ]);
    return (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, jobSearchType_objectSpread({
        bgColor: "background.750",
        maxW: {
            base: 320,
            sm: 350,
            md: 'full'
        },
        h: 386,
        pt: 6,
        paddingX: 12
    }, props, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* default */.Z, {
                format: "h2",
                color: "primary.500",
                fontWeight: 600,
                textAlign: "center",
                mb: 2,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                textAlign: "center",
                fontSize: "2xl",
                fontWeight: 600,
                mb: 4,
                children: subtitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                textAlign: "center",
                maxW: 400,
                color: "text.200",
                mb: 10,
                children: text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                src: src,
                height: imageHeight,
                width: imageWidth,
                layout: "responsive",
                alt: alt
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./src/components/organisms/home/benefits/index.tsx








var HomePageBenefits = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
        bgColor: "background.700",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Container */.W2, {
            maxW: "container.lg",
            paddingY: 12,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                    textTransform: "uppercase",
                    color: "primary.500",
                    fontWeight: 700,
                    textAlign: "center",
                    mb: 4,
                    children: "O processo seletivo na plataforma"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* default */.Z, {
                    as: "h2",
                    textAlign: "center",
                    fontWeight: 600,
                    mb: 10,
                    children: "Por que profissionais amam a Geek?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Grid */.rj, {
                    templateColumns: {
                        base: '1fr',
                        md: 'repeat(2, 1fr)'
                    },
                    gap: {
                        base: 0,
                        md: 4
                    },
                    mb: {
                        base: 64,
                        sm: 72,
                        md: 80,
                        lg: 96
                    },
                    justifyItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                            justifySelf: {
                                base: 'auto',
                                lg: 'right'
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JobSearchType, {
                                src: "/benefits/running-girl.png",
                                imageHeight: 837,
                                imageWidth: 697,
                                alt: "Garota correndo com pressa.",
                                title: "Tradicional",
                                subtitle: "Voc\xea vai at\xe9 as empresas",
                                text: "Voc\xea acha uma vaga e corre para preench\xea-la o mais r\xe1pido poss\xedvel. Encontrando outra voc\xea deve fazer tudo de novo.",
                                mb: {
                                    base: 56,
                                    md: 'auto'
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                            justifySelf: {
                                base: 'auto',
                                lg: 'left'
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JobSearchType, {
                                src: "/benefits/walking-guy.png",
                                imageHeight: 946,
                                imageWidth: 728,
                                alt: "Garoto andando tranquilo.",
                                title: "GeekHunter",
                                subtitle: "As empresas v\xe3o at\xe9 voc\xea",
                                text: "Preencha seu perfil uma \xfanica vez e receba oportunidades de trabalho coerentes com o seu hist\xf3rico profissional e interesses."
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Grid */.rj, {
                    templateColumns: {
                        base: '1fr',
                        md: 'repeat(3, 1fr)'
                    },
                    gap: 4,
                    mb: 12,
                    justifyItems: {
                        base: 'center',
                        xl: 'unset'
                    },
                    alignItems: "stretch",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitCard, {
                                src: "/benefits/job-proposals.png",
                                alt: "Pap\xe9is com propostas de emprego.",
                                title: "Compare\npropostas",
                                text: "Voc\xea est\xe1 no controle. Deixe as empresas irem at\xe9 voc\xea. Compare vagas, receba convites de entrevista e conhe\xe7a a faixa de remunera\xe7\xe3o antes de conversar com a empresa."
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitCard, {
                                src: "/benefits/privacy.png",
                                alt: "Rosto com apenas chap\xe9u e \xf3culos.",
                                title: "Privacidade\nde perfil",
                                text: "Oculte seu perfil para empregadores antigos e atuais. N\xf3s s\xf3 iremos te recomendar para vagas que tenham a ver com o seu perfil."
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitCard, {
                                src: "/benefits/shinning-coins.png",
                                alt: "Pilha de moedas reluzindo.",
                                title: "Gratuito para \nprofissionais",
                                text: "Conte sempre com a GeekHunter. Estamos aqui para ajudar profissionais de tecnologia. Voc\xea n\xe3o paga nada para utilizar a plataforma!"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Center */.M5, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        href: paths/* CANDIDATE_LP */.Is,
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                            p: 4,
                            children: "Criar conta como profissional"
                        })
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/atoms/images/brandLogo/index.tsx
var brandLogo = __webpack_require__(15302);
;// CONCATENATED MODULE: ./src/components/organisms/home/brands/index.tsx



var companiesLogos = [
    {
        src: '/companies/amazon-pb.png',
        alt: 'Amazon',
        w: [
            130
        ],
        h: [
            40
        ]
    },
    {
        src: '/companies/zup-pb.png',
        alt: 'Zup',
        w: [
            68
        ],
        h: [
            31
        ]
    },
    {
        src: '/companies/hostgator-pb.png',
        alt: 'HostGator',
        w: [
            164
        ],
        h: [
            29
        ]
    },
    {
        src: '/companies/mercado-livre-pb.png',
        alt: 'Mercado Livre',
        w: [
            149
        ],
        h: [
            38
        ]
    },
    {
        src: '/companies/rank-my-app-pb.png',
        alt: 'Rank My App',
        w: [
            134
        ],
        h: [
            48
        ]
    }, 
];
var HomePageBrands = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
        bgColor: "background.700",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Container */.W2, {
            maxW: "container.lg",
            paddingY: 12,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                    textTransform: "uppercase",
                    fontWeight: 700,
                    textAlign: "center",
                    mb: 10,
                    color: "primary.500",
                    children: "Algumas empresas que j\xe1 contrataram com a geekhunter"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Center */.M5, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Grid */.rj, {
                        templateColumns: {
                            base: 'repeat(2, 1fr)',
                            md: 'repeat(5, 1fr)'
                        },
                        maxW: {
                            base: 400,
                            md: 1000
                        },
                        gap: 4,
                        children: companiesLogos.map(function(companieLogo) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Center */.M5, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                                    "data-testid": "company-logo",
                                    paddingX: 4,
                                    textAlign: "center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(brandLogo/* default */.Z, {
                                        src: companieLogo.src,
                                        alt: companieLogo.alt,
                                        h: companieLogo.h,
                                        w: companieLogo.w
                                    })
                                }, companieLogo.alt)
                            }, companieLogo.alt);
                        })
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/lib/utils/textUtils/index.ts
var textUtils = __webpack_require__(53087);
;// CONCATENATED MODULE: ./src/components/molecules/home/companiesCard/index.tsx




function companiesCard_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function companiesCard_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            companiesCard_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function companiesCard_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = companiesCard_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function companiesCard_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var CompaniesCard = function(_param) /*#__PURE__*/ {
    var subtitle = _param.subtitle, text = _param.text, title = _param.title, starredTitle = _param.starredTitle, props = companiesCard_objectWithoutProperties(_param, [
        "subtitle",
        "text",
        "title",
        "starredTitle"
    ]);
    return (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, companiesCard_objectSpread({
        background: "background.700",
        p: {
            base: 6,
            sm: 12
        },
        boxShadow: "md"
    }, props, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                textTransform: "uppercase",
                fontWeight: 700,
                color: "primary.500",
                children: subtitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* default */.Z, {
                as: "h3",
                mt: 0,
                maxWidth: 450,
                paddingY: 8,
                children: (0,textUtils/* starredText */.O)(title, starredTitle, {
                    fontWeight: '700'
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                maxWidth: 450,
                children: text
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./src/components/organisms/home/companies/index.tsx







var companies_companiesLogos = [
    {
        src: '/companies/mercado-livre-color-new.png',
        alt: 'Mercado Livre',
        w: [
            131
        ],
        h: [
            33
        ]
    },
    {
        src: '/companies/rank-my-app-color-new.png',
        alt: 'Rank My App',
        w: [
            121
        ],
        h: [
            42
        ]
    },
    {
        src: '/companies/zup-color-new.png',
        alt: 'Zup',
        w: [
            85
        ],
        h: [
            41
        ]
    },
    {
        src: '/companies/amazon-color-new.png',
        alt: 'Amazon',
        w: [
            114
        ],
        h: [
            34
        ]
    },
    {
        src: '/companies/hostgator-color.png',
        alt: 'Hostgator',
        w: [
            144
        ],
        h: [
            25
        ]
    }, 
];
var HomePageCompanies = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
        bgColor: "background.850",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Container */.W2, {
            maxW: "container.lg",
            paddingY: 12,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                    justify: "space-between",
                    alignItems: "center",
                    flexDir: {
                        base: 'column',
                        md: 'row'
                    },
                    mb: 12,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Grid */.rj, {
                            templateColumns: {
                                base: 'repeat(2, 1fr)',
                                md: 'repeat(3, 1fr)'
                            },
                            templateRows: {
                                base: 'repeat(3, 1fr)',
                                md: 'repeat(2, 1fr)'
                            },
                            maxW: 600,
                            gap: 4,
                            children: companies_companiesLogos.map(function(companieLogo) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Center */.M5, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                                        p: [
                                            2,
                                            2,
                                            8,
                                            8
                                        ],
                                        "data-testid": "company-logo",
                                        textAlign: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(brandLogo/* default */.Z, {
                                            src: companieLogo.src,
                                            alt: companieLogo.alt,
                                            h: companieLogo.h,
                                            w: companieLogo.w
                                        })
                                    }, companieLogo.alt)
                                }, companieLogo.alt);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CompaniesCard, {
                            subtitle: "GEEKHUNTER PARA EMPRESA",
                            title: "Contrate os melhores talentos do mercado tech para a sua empresa",
                            starredTitle: [
                                'para',
                                'a',
                                'sua',
                                'empresa'
                            ],
                            text: "Busque por profissionais e receba recomenda\xe7\xf5es certeiras, de acordo com a sua necessidade. Contrate r\xe1pido e contrate bem."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Center */.M5, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        href: {
                            pathname: paths/* COMPANY_PLANS_LP */.Oi
                        },
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                            p: 4,
                            children: "Confira nossos planos"
                        })
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/molecules/home/jobCard/index.tsx
var jobCard = __webpack_require__(48563);
;// CONCATENATED MODULE: ./src/components/organisms/home/jobs/index.tsx







var _remoteWork, ref, _slug, _technologies, _title;
var HomePageJobs = function(param) {
    var jobs = param.jobs;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
        bgColor: "background.750",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Container */.W2, {
            maxW: "container.xxl",
            paddingY: 12,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                    textTransform: "uppercase",
                    color: "primary.500",
                    fontWeight: 700,
                    textAlign: "center",
                    mb: 4,
                    children: "AUMENTE AS CHANCES DO SEU PERFIL SER VISTO PELAS EMPRESAS"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(heading/* default */.Z, {
                    as: "h2",
                    textAlign: "center",
                    fontWeight: 600,
                    mb: 10,
                    children: [
                        "Crie sua conta e demonstre",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "interesse nas vagas"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* SimpleGrid */.MI, {
                    columns: {
                        base: 1,
                        md: 2,
                        lg: 3
                    },
                    gap: 4,
                    mb: 12,
                    children: jobs.map(function(job) {
                        var ref1;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(jobCard/* JobCard */.t, {
                            acceptRemote: (_remoteWork = job.remoteWork) !== null && _remoteWork !== void 0 ? _remoteWork : false,
                            hybrid: job.hybrid,
                            city: (ref = (ref1 = job.city) === null || ref1 === void 0 ? void 0 : ref1.name) !== null && ref !== void 0 ? ref : '',
                            pjSalaryMax: job.pjMaxSalary,
                            pjSalaryMin: job.pjMinSalary,
                            cltSalaryMax: job.cltMaxSalary,
                            cltSalaryMin: job.cltMinSalary,
                            usdAnnualSalaryMin: job.usdAnnualSalaryMin,
                            usdAnnualSalaryMax: job.usdAnnualSalaryMax,
                            slug: (_slug = job.slug) !== null && _slug !== void 0 ? _slug : '',
                            techs: (_technologies = job.technologies) !== null && _technologies !== void 0 ? _technologies : [],
                            hideSalary: job.hideSalary,
                            title: (_title = job.title) !== null && _title !== void 0 ? _title : '',
                            isInternational: job.isInternational,
                            jobType: job.jobType,
                            companySlug: job.company.slug
                        }, job.id);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Grid */.rj, {
                    templateColumns: {
                        base: '1fr',
                        md: 'repeat(2, 1fr)'
                    },
                    gap: 4,
                    justifyItems: {
                        base: 'center',
                        sm: 'unset'
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                            justifySelf: {
                                base: 'center',
                                md: 'right'
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                href: paths/* CANDIDATE_LP */.Is,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                                    p: 4,
                                    children: "Criar conta como profissional"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                            justifySelf: {
                                base: 'center',
                                md: 'left'
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                href: paths/* JOBS */.WN,
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_button/* default */.Z, {
                                    p: 3,
                                    variant: "outline",
                                    children: "Ver mais vagas"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/atoms/statsBox/index.tsx



function statsBox_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function statsBox_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            statsBox_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function statsBox_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = statsBox_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function statsBox_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var StatsBox = function(_param) /*#__PURE__*/ {
    var title = _param.title, text = _param.text, props = statsBox_objectWithoutProperties(_param, [
        "title",
        "text"
    ]);
    return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, statsBox_objectSpread({
            background: "background.700",
            width: {
                base: 280,
                sm: 300,
                md: 'full'
            },
            paddingY: 6
        }, props, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* default */.Z, {
                    as: "h2",
                    textAlign: "center",
                    color: "primary.500",
                    fontSize: "5xl",
                    mt: 0,
                    paddingTop: 0,
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* default */.Z, {
                    as: "h3",
                    mt: 0,
                    textAlign: "center",
                    fontSize: "2xl",
                    dangerouslySetInnerHTML: {
                        __html: text
                    },
                    paddingBottom: 2
                })
            ]
        }))
    });
};


;// CONCATENATED MODULE: ./src/components/organisms/home/stats/index.tsx





var HomePageStats = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
        bgColor: "background.200",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Container */.W2, {
            maxW: "container.lg",
            paddingY: 12,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                    textTransform: "uppercase",
                    fontWeight: 700,
                    textAlign: "center",
                    color: "primary.500",
                    letterSpacing: "1px",
                    mb: 4,
                    children: "OS N\xdaMEROS PODEM DIZER MAIS"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
                    alignItems: "flex-start",
                    justifyContent: "center",
                    mb: 10,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* default */.Z, {
                        as: "h2",
                        maxWidth: 700,
                        textAlign: "center",
                        children: (0,textUtils/* starredText */.O)('A GeekHunter \xe9 eficiente para profissionais e empresas de tecnologia', [
                            'profissionais',
                            'e',
                            'empresas',
                            'de',
                            'tecnologia'
                        ], {
                            fontWeight: '700'
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Grid */.rj, {
                    templateColumns: {
                        base: '1fr',
                        md: 'repeat(3, 1fr)'
                    },
                    gap: 4,
                    justifyItems: {
                        base: 'center',
                        md: 'stretch'
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StatsBox, {
                                title: "+5 mil",
                                text: "oportunidades <br /> de trabalho"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StatsBox, {
                                title: "+500",
                                text: "empresas <br /> contratando"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StatsBox, {
                                title: "+130 mil",
                                text: "convites para <br /> entrevistas"
                            })
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/organisms/landingPageHeader/index.tsx + 1 modules
var landingPageHeader = __webpack_require__(28147);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(56168);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/chakra-ui-system.esm.js + 5 modules
var chakra_ui_system_esm = __webpack_require__(47386);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.js + 150 modules
var motion = __webpack_require__(24909);
;// CONCATENATED MODULE: ./src/components/molecules/home/testimonialsCard/index.tsx






function testimonialsCard_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function testimonialsCard_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            testimonialsCard_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function testimonialsCard_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = testimonialsCard_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function testimonialsCard_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var MotionBox = (0,motion/* motion */.E)(chakra_ui_layout_esm/* Box */.xu);
var MotionFlex = (0,motion/* motion */.E)(chakra_ui_layout_esm/* Flex */.kC);
var variants = {
    flipFront: {
        rotateY: '180deg',
        transition: {
            duration: 0.5
        }
    },
    flipBack: {
        rotateY: '0deg',
        transition: {
            duration: 0.5
        }
    },
    hideBack: {
        rotateY: '-180deg',
        transition: {
            duration: 0.5
        }
    }
};
var TestimonialCard = function(_param) {
    var coverText = _param.coverText, backText = _param.backText, src = _param.src, alt = _param.alt, name = _param.name, job = _param.job, props = testimonialsCard_objectWithoutProperties(_param, [
        "coverText",
        "backText",
        "src",
        "alt",
        "name",
        "job"
    ]);
    var primary500 = (0,chakra_ui_system_esm/* useToken */.dQ)('colors', 'primary.500');
    var ref = (0,react.useState)(false), isHovered = ref[0], setHovered = ref[1];
    var toggleIsHovered = function() {
        return setHovered(!isHovered);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(MotionBox, {
        h: {
            base: 410,
            md: 500,
            lg: 410
        },
        maxW: {
            base: 320,
            sm: 480
        },
        position: "relative",
        onMouseEnter: toggleIsHovered,
        onMouseLeave: toggleIsHovered,
        style: {
            perspective: 1000
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MotionFlex, testimonialsCard_objectSpread({
                flexDirection: "column",
                justifyContent: "space-between",
                boxShadow: "md",
                paddingY: 8,
                paddingX: 6,
                mb: {
                    base: 6,
                    md: 0
                },
                bgColor: "background.700",
                position: "absolute",
                h: "full",
                style: {
                    backfaceVisibility: 'hidden'
                },
                animate: isHovered ? 'flipFront' : 'flipBack',
                variants: variants
            }, props, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                        fontSize: "2xl",
                        fontWeight: 600,
                        lineHeight: 8,
                        children: (0,textUtils/* starredText */.O)(coverText.text, coverText.starring, {
                            color: primary500
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                        textTransform: "uppercase",
                        color: "primary.500",
                        textDecoration: "underline",
                        fontSize: "sm",
                        children: "Ver depoimento"
                    })
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MotionFlex, testimonialsCard_objectSpread({
                flexDirection: "column",
                justifyContent: "space-between",
                boxShadow: "md",
                paddingY: 8,
                paddingX: 6,
                mb: {
                    base: 6,
                    md: 0
                },
                bgColor: "background.700",
                h: "full",
                style: {
                    backfaceVisibility: 'hidden'
                },
                animate: isHovered ? 'flipBack' : 'hideBack',
                variants: variants,
                initial: "hideBack"
            }, props, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                        color: "text.200",
                        children: backText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                width: 51,
                                height: 51,
                                src: src,
                                alt: alt
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                                ml: 3,
                                justifyContent: "center",
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                        color: "primary.500",
                                        fontSize: "sm",
                                        children: name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                        fontSize: "sm",
                                        children: job
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }))
        ]
    }));
};


;// CONCATENATED MODULE: ./src/components/organisms/home/testimonials/index.tsx





var HomePageTestimonials = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
        bgColor: "background.200",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Container */.W2, {
            maxW: "container.lg",
            paddingY: 12,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                flexDirection: "column",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                        textTransform: "uppercase",
                        color: "primary.500",
                        fontWeight: 700,
                        textAlign: "center",
                        mb: 4,
                        children: "Para se inspirar"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* default */.Z, {
                        textAlign: "center",
                        as: "h2",
                        fontWeight: 600,
                        mb: 10,
                        w: {
                            base: 'full',
                            sm: 490
                        },
                        children: (0,textUtils/* starredText */.O)('Vidas transformadas pela GeekHunter', [
                            'Vidas',
                            'transformadas'
                        ], {
                            fontWeight: '700'
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Grid */.rj, {
                        templateColumns: {
                            base: '1fr',
                            md: 'repeat(3, 1fr)'
                        },
                        gap: 3,
                        justifyItems: "center",
                        maxW: 1000,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialCard, {
                                    coverText: {
                                        text: 'Guilherme adorou como foi atendido pela nossa equipe e foi contratado na ActualSales 💸',
                                        starring: [
                                            'Guilherme',
                                            'nossa equipe',
                                            'ActualSales'
                                        ]
                                    },
                                    backText: "A GeekHunter me surpreendeu! A plataforma \xe9 bastante eficaz! Vale tamb\xe9m falar da aten\xe7\xe3o dos funcion\xe1rios. Todos que falaram comigo me trataram super bem e sempre acompanharam todo o processo de sele\xe7\xe3o, tirando d\xfavidas e ajudando no que fosse necess\xe1rio. Recomendo muito!",
                                    name: "Guilherme Assemany",
                                    job: "Gerente de Projetos",
                                    src: "/geeks/geek1.webp",
                                    alt: "Foto do gerente de projetos Guilherme Assemany"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialCard, {
                                    coverText: {
                                        text: 'Daniela amou a plataforma e foi contratada como desenvolvedora Full-Stack na Sislogica 🚚',
                                        starring: [
                                            'Daniela',
                                            'desenvolvedora',
                                            'Sislogica'
                                        ]
                                    },
                                    backText: "Quando me cadastrei na GeekHunter j\xe1 comecei gostando muito da plataforma. Ela tem tudo que um profissional da \xe1rea de TI precisa mostrar para as empresas. Achei muito legal os feedbacks que enviam por email te atualizando sobre os processos seletivos e as dicas que d\xe3o para melhorar o perfil e ser mais visto entre as empresas.",
                                    name: "Daniela Cruz Tirado",
                                    job: "Desenvolvedora",
                                    src: "/geeks/geek2.webp",
                                    alt: "Foto da desenvolvedora Daniela Cruz Tirado"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialCard, {
                                    coverText: {
                                        text: 'F\xe1bio fez sua primeira entrevista ap\xf3s uma semana aprovado e foi contratado pela Tapps Games 🎮',
                                        starring: [
                                            'F\xe1bio',
                                            'entrevista',
                                            'uma semana',
                                            'Tapp Games'
                                        ]
                                    },
                                    backText: "Me interessei pelo modelo de contrata\xe7\xe3o e me cadastrei. As provas foram simples e diretas, mas sempre cobrando algum conte\xfado chave. Depois de aprovado n\xe3o demorou uma semana at\xe9 a primeira entrevista. Adorei o lugar e estou nele at\xe9 hoje. Recomendo e muito este servi\xe7o para todos os meus amigos da \xe1rea.",
                                    name: "Fabio Gunkel",
                                    job: "Desenvolvedor",
                                    src: "/geeks/geek3.webp",
                                    alt: "Foto do desenvolvedor Fabio Gunkel"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/templates/home/index.tsx











var SiteHomePage = function(param) {
    var jobs = param.jobs;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(landingPageHeader/* default */.Z, {
                headerLinks: header/* headerLinks */.Gb
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePageBanner, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePageBrands, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePageStats, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePageBenefits, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePageCompanies, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePageTestimonials, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePageJobs, {
                jobs: jobs
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* Footer */.$, {})
        ]
    });
};

// EXTERNAL MODULE: ./src/components/atoms/themeProvider/index.tsx + 2 modules
var themeProvider = __webpack_require__(92015);
// EXTERNAL MODULE: ./src/components/atoms/nextSeo/index.tsx
var nextSeo = __webpack_require__(63198);
;// CONCATENATED MODULE: ./src/pages/index.page.tsx






var monolithLink = "https://www.geekhunter.com.br" || 0;
var Index = function(param) {
    var jobs = param.jobs;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(themeProvider/* ThemeProvider */.f, {
        colors: company/* companyColorScheme */.T,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(nextSeo/* NextSeo */.P, {
                title: "Geekhunter: Recrute Talentos tech | Vagas para profissionais tech",
                description: "Conectamos os melhores profissionais de tecnologia \xe0s empresas mais desejadas!",
                canonical: "".concat(monolithLink).concat(paths/* ROOT */.Dx)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SiteHomePage, {
                jobs: jobs
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var index_page = (Index);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,4617,6556,1190,9161,401,9826,1930,8563,9774,2888,179], function() { return __webpack_exec__(86057); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);